import { render, staticRenderFns } from "./NewIQCAdminData.vue?vue&type=template&id=fb4f3b5e&scoped=true"
import script from "./NewIQCAdminData.vue?vue&type=script&lang=js"
export * from "./NewIQCAdminData.vue?vue&type=script&lang=js"
import style0 from "./NewIQCAdminData.vue?vue&type=style&index=0&id=fb4f3b5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4f3b5e",
  null
  
)

export default component.exports